const EVENT_NAMES = [
  ".zadanie.created",
  ".zadanie.updated",
  ".zadanie.deleted",
];

export function createTaskSubscription({ initialize, getEcho, onEvent, onReconnect }) {
  let consumers = 0;
  let channel = null;
  let connection = null;
  let starting = null;
  const handlers = new Map();

  async function start() {
    consumers += 1;
    if (channel) return;
    if (starting) return starting;

    starting = (async () => {
      if (!getEcho()) await initialize();
      const echo = getEcho();
      if (!echo || consumers === 0) return;

      channel = echo.private("zadania");
      for (const name of EVENT_NAMES) {
        const handler = (event) => onEvent(event);
        handlers.set(name, handler);
        channel.listen(name, handler);
      }

      connection = echo.connector?.pusher?.connection ?? null;
      connection?.bind?.("connected", onReconnect);
    })().finally(() => { starting = null; });

    return starting;
  }

  function stop() {
    consumers = Math.max(0, consumers - 1);
    if (consumers > 0 || !channel) return;

    for (const [name, handler] of handlers) channel.stopListening(name, handler);
    handlers.clear();
    connection?.unbind?.("connected", onReconnect);
    getEcho()?.leaveChannel("zadania");
    channel = null;
    connection = null;
  }

  return { start, stop, consumerCount: () => consumers };
}
